import { render, staticRenderFns } from "./SalesOrderItem.vue?vue&type=template&id=0eaec3e4&"
import script from "./SalesOrderItem.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderItem.vue?vue&type=script&lang=ts&"
import style0 from "./SalesOrderItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports